import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AlertController, PopoverController } from '@ionic/angular';
import { filter, map, Observable, of, tap } from 'rxjs';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { ApproveRejectService } from '../../../company/service/approve-reject.service';
import { addCompanyFormField } from '../../forms/add-company';
import { JobfairService } from '../../service/jobfair.service';
import { ParticipateCompanyService } from './service/participate-company.service';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';
import { environment } from 'src/environments/environment';
@Component({
	selector: 'app-participatingcompanies',
	templateUrl: './participatingcompanies.page.html',
	styleUrls: ['./participatingcompanies.page.scss'],
})
export class ParticipatingcompaniesPage implements OnInit {
	participateCompany$: Observable<any> = of(null);
	companyArr: any;
	jobfairId: number = 0;
	allCompany$: any;
	jobFairName: any;
	specialFair = environment.specialFair;

	constructor(
		private participateCompanyService: ParticipateCompanyService,
		private popoverController: PopoverController,
		private location: Location,
		private alertController: AlertController,
		private ngrxService: NgrxService,
		private jobFairService: JobfairService,
		private approveRejectService: ApproveRejectService,
	) {
		//
	}

	ngOnInit() {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.jobfairId = locationPath[4];

		this.participateCompanyService.loadcompanyinit(this.jobfairId).subscribe();
		this.participateCompanyService.loadcompanyapi(this.jobfairId).subscribe();
		this.participateCompany$ = this.participateCompanyService.fetchcompanydata(
			this.jobfairId,
		);

		this.approveRejectService.loadCompanyDataApi('approved').subscribe();
		this.allCompany$ = this.approveRejectService
			.fetchCompanyData()
			.pipe(filter((data: any) => !data.isSkeleton && data.data.length > 0));

		//for special fair
		this.jobFairService.loadJobFairListData().subscribe();

		this.jobFairService.fetchJobFairListData().subscribe((data: any) => {
			if (data.data.data) {
				this.jobFairName = data.data.data.find(
					(data: any) => data.id == this.jobfairId,
				);
			}
		});
	}

	// getParticipateCompanies(jobfairId: number) {
	// 	this.participateCompany$ = this.participateCompanyService
	// 		.getCompany(jobfairId)
	// 		.pipe(map(({ data }: any) => data));
	// }

	isCanOpenBox = true;

	async addParticipate(companyList: any) {
		if (this.isCanOpenBox) {
			console.log(this.companyArr);
			this.isCanOpenBox = false;
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Add participating company',
					form: addCompanyFormField,
					multiValueSelect: { selectCompany: true },
					selectOptions: {
						selectCompany: companyList.data,
					},
					jobfairId: this.jobfairId,
					onSubmitForm: this.onCreate,
					ref: this,
				},
			});

			modal.style.cssText = `--max-width: 540px;--min-width: 540px;--max-height: 540px;--min-height: 540px;`;

			await modal.present();

			const { data } = await modal.onDidDismiss();

			// if (data?.reload) {
			// 	this.getParticipateCompanies(this.jobfairId);
			// }

			this.isCanOpenBox = true;
		}
	}

	onCreate(ref: any, editForm: any) {
		console.log(ref.jobfairId, editForm);
		return ref.participateCompanyService.addCompany(
			this.jobfairId,
			editForm.selectCompany,
		);
	}

	removeParticipateCompany(company: any) {
		this.participateCompanyService
			.removeCompany(this.jobfairId, company.id, company.jobFairCompanyId)
			.subscribe(() => {
				// this.getParticipateCompanies(this.jobfairId);
			});
	}

	handleChange(ev: any, id: any) {
		if (ev.target.value === 'approved') {
			this.participateCompanyService
				.approveState(this.jobfairId, id)
				.subscribe();
		} else if (ev.target.value === 'rejected') {
			this.participateCompanyService
				.rejectState(this.jobfairId, id)
				.subscribe();
		}
	}
}
